import React from "react";
import { ReaderItem } from "../../../models/reader";
import coming_soon_img from "../../assets/coming-soon.png";
import with_audio from "../../assets/withAudio.png";
import new_img from "../../assets/new-icon.png";
import { getAuthCookie } from "../../../middleware/cookie-manager";

type ReaderBlockProps = {
  reader: ReaderItem;
  slectActiveReader?: any;
  cat_id?: string;
  rowNum: number;
  xval: number;
  xselected?: boolean;
};

const ReaderBlock: React.FC<ReaderBlockProps> = ({
  reader,
  slectActiveReader,
  cat_id,
  rowNum,
  xval,
  xselected,
}) => {
  const user = getAuthCookie(true);

  const block_id = `${reader.id}${reader.is_author ? "_author" : ""}`;
  return (
    <button
      onClick={slectActiveReader}
      data-id={`${block_id}`}
      data-cat_id={cat_id}
      data-rownum={rowNum}
      data-xval={xval}
      className={`reader_block_item  ${xselected ? "selected" : ""}`}
    >
      {reader.coming_soon ? (
        <img src={coming_soon_img} className="coming_soon" alt="Coming soon" />
      ) : reader.is_new ? (
        <img src={new_img} className="is_new" alt="Coming soon" />
      ) : reader.categories.findIndex((c) => c.id === "19") >= 0 ? (
        <img
          src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/LimTime.png?v=4"
          className="is_new"
          alt="Coming soon"
          style={{ border: "1px solid white", margin: "5px" }}
        />
      ) : null}
      {user.plan?.plan_id === "2" && reader.id !== "12" ? (
        <img src={with_audio} className="with_audio" alt="Coming soon" />
      ) : null}
      <div className="bg-img">
        {reader.images ? <img src={reader.images?.cover} alt="" /> : null}
      </div>
    </button>
  );
};

export default ReaderBlock;
